import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/dalvirushikesh'
      className='link footer__link'
    >
      Created By Rushikesh Dalvi
    </a>
  </footer>
)

export default Footer
